module.exports = __webpack_public_path__ + "assets/img/hero-background.6789a97c.svg";